/**
 * 图片剪裁
 * @param src
 * @param w
 * @param h
 */
export function resizeImg(src: string, w: number, h?: number) {
  if (typeof src !== 'string') return src;
  if (src.indexOf('.360buyimg.com/') === -1) return src;
  if (typeof w !== 'number') return src;
  if (typeof h === 'undefined') h = w;
  // 防止路径中出现jfs同名字符串，所以在后面加了一个斜杠
  return src.replace('jfs/', `s${w}x${h}_jfs/`);
}

/**
 * 图片下载
 * @param imgUrl
 */
export default function downloadImg(imgUrl: string, name: string) {
  const image = new Image();
  // 解决跨域 canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = function () {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context && context.drawImage(image, 0, 0, image.width, image.height);
    // 得到图片的base64编码数据
    const url = canvas.toDataURL('image/png');
    downloadImgByBase64(url, name);
  };
  image.src = imgUrl;
}

export function downloadImgByBase64(base64String: string, name: string) {
  const a = document.createElement('a');
  // 创建一个点击事件
  const event = new MouseEvent('click');
  // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
  a.download = name;
  // 将生成的 URL 设置为 a.href 属性
  a.href = base64String;
  // 触发 a 的点击事件
  a.dispatchEvent(event);
  // return a;
}
